// rsvp strings (ar).
const rsvp = {
	rsvp: {
		going: 'سأحضر',
		maybe: 'ربما',
		cantGo: 'لا أستطيع الحضور',
		respondPrompt: 'هل ستحضر؟',
		guests: 'ضيوف إضافيون',
		guestsLabel: 'عدد الضيوف الإضافيين',
		note: 'ملاحظة للمضيف (اختياري)',
		notePlaceholder: 'أضف ملاحظة',
		save: 'حفظ الرد',
		saving: 'جارٍ الحفظ...',
		thanks: 'شكرًا لك، تم حفظ ردك.',
		change: 'تغيير الرد',
		useYourLink: 'افتح رابط دعوتك الشخصي للرد.',
		joinOnline: 'انضم عبر الإنترنت',
		addToCalendar: 'أضف إلى التقويم',
		googleCalendar: 'تقويم Google',
		appleOutlook: 'Apple / Outlook (.ics)',
		error: 'حدث خطأ ما. يرجى المحاولة مرة أخرى بعد قليل.',
		invalid: 'يرجى مراجعة ردك والمحاولة مرة أخرى.',
		notFound: 'تعذر العثور على هذه الدعوة.',
		hostNote: 'ملاحظة من المضيف',
		decrease: 'إزالة ضيف',
		increase: 'إضافة ضيف',
		yourResponse: 'ردك',
		dashboard: {
			tab: 'الردود',
			noReply: 'لم يرد',
			plusGuests: { one: '+{{count}} ضيف', other: '+{{count}} ضيوف' },
			all: 'الكل',
			filter: 'تصفية حسب الرد',
			export: 'تصدير CSV',
			name: 'الاسم',
			email: 'البريد الإلكتروني',
			response: 'الرد',
			guestsCol: 'الضيوف',
			noteCol: 'ملاحظة',
			updated: 'آخر تحديث',
			empty: 'لا يوجد مستلمون بعد',
			loading: 'جارٍ تحميل الردود...',
			forbidden: 'غير مسموح لك بعرض ردود هذه البطاقة.',
			error: 'تعذر تحميل الردود. يرجى المحاولة مرة أخرى.',
			noMatches: 'لا يوجد مستلمون يطابقون هذا المرشح',
			summary: 'ملخص الردود',
		},
	},
};

export default rsvp;
